"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var getServiceUrl = function (srv) { return "/tools/".concat((srv === null || srv === void 0 ? void 0 : srv.metaCategoryId) || 'other', "/").concat(srv === null || srv === void 0 ? void 0 : srv.slug); };
var BrandedServiceLink = function (_a) {
    var service = _a.service, searchParams = _a.searchParams;
    return ((0, jsx_runtime_1.jsx)(LogoAndName_1.default, { url: "".concat(getServiceUrl(service)).concat(searchParams ? "?".concat(searchParams) : ''), brand: service, size: "sm", noWrap: false }));
};
exports.default = BrandedServiceLink;
